require.register("modules/m0x/a02/page-13-he/page-13-he", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_13_he = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_13_he;

  
});

